import axios from 'axios';

// 容量分析相關 API
export const capacityAnalysis = {
  // 取得指定容量分析
  get: async (capacityAnalysisId, projectId) => {
    const response = await axios.get('/api/MRTCA/CapacityAnalysis/Get', {
      params: {
        CapacityAnalysisId: capacityAnalysisId,
        ProjectId: projectId
      }
    });
    return response.data;
  },

  // 取得指定專案的所有容量分析歷史紀錄
  getAnalysesByProjectId: async (projectId) => {
    if (!projectId) {
      console.error("getAnalysesByProjectId: ProjectId is required.");
      throw new Error("ProjectId is required to fetch analyses history.");
    }
    const response = await axios.get('/api/MRTCA/CapacityAnalysis/Get', {
      params: {
        // CapacityAnalysisId is intentionally omitted to get all analyses for the project
        ProjectId: projectId
      }
    });
    // The response for fetching by ProjectId should be MRTCA.CapacityAnalysisGetResponse
    // which contains a CapacityAnalyses array.
    return response.data;
  },

  // 建立容量分析
  create: async (projectId) => {
    const response = await axios.post('/api/MRTCA/CapacityAnalysis/Create', {
      ProjectId: projectId
    });
    return response.data;
  },

  // 取得容量分析進度
  getProgress: async (processId) => {
    const response = await axios.get('/api/MRTCA/CapacityAnalysis/GetProgress', {
      params: {
        ProcessId: processId
      }
    });
    return response.data;
  },

  // 取得容量分析結果
  getResult: async (capacityAnalysisId) => {
    const response = await axios.get('/api/MRTCA/CapacityAnalysis/GetResult', {
      params: {
        CapacityAnalysisId: capacityAnalysisId
      }
    });
    return response.data;
  },

  // 取得容量分析結果索引
  getResultIndex: async (projectId, limit, page) => {
    const response = await axios.get('/api/MRTCA/CapacityAnalysis/GetResultIndex', {
      params: {
        ProjectId: projectId,
        Limit: limit,
        Page: page
      }
    });
    return response.data;
  }
};

// 中央避車線相關 API
export const centralLine = {
  // 取得指定中央避車線
  get: async (centralLineId) => {
    const response = await axios.get('/api/MRTCA/CentralLine/Get', {
      params: {
        CentralLineId: centralLineId
      }
    });
    return response.data;
  },

  // 更新中央避車線
  update: async (params) => {
    const response = await axios.put('/api/MRTCA/CentralLine/Update', params);
    return response.data;
  }
};

// 銜接點相關 API
export const connectingPoint = {
  // 取得指定銜接點
  get: async (connectingPointId) => {
    const response = await axios.get('/api/MRTCA/ConnectingPoint/Get', {
      params: {
        ConnectingPointId: connectingPointId
      }
    });
    return response.data;
  },

  // 更新銜接點
  update: async (params) => {
    const response = await axios.put('/api/MRTCA/ConnectingPoint/Update', params);
    return response.data;
  }
};

// 欄位約束相關 API
export const fieldConstraint = {
  // 取得已設定的檢核設定欄位值
  get: async (table, column) => {
    const response = await axios.get('/api/MRTCA/FieldConstraint/Get', {
      params: {
        Table: table,
        Column: column
      }
    });
    return response.data;
  },

  // 更新檢核設定欄位值
  update: async (params) => {
    const response = await axios.put('/api/MRTCA/FieldConstraint/Update', params);
    return response.data;
  },

  // 更新全域參數檢核設定
  updateGlobalSetting: async (params) => {
    try {
      console.log('正在更新MRTCA全域參數檢核設定:', params);
      
      const response = await axios.put('/api/MRTCA/FieldConstraint/UpdateGlobalSetting', params);
      
      console.log('MRTCA全域參數檢核設定更新響應:', response.data);
      
      if (!response.data) {
        throw new Error('響應數據為空');
      }

      // 添加Success字段以保持一致性
      if (typeof response.data.Success === 'undefined') {
        response.data.Success = true;
      }

      return response.data;
    } catch (error) {
      console.error('更新MRTCA全域參數檢核設定失敗:', error);
      throw error;
    }
  },

  // 更新列車參數檢核設定
  updateTrain: async (params) => {
    try {
      console.log('正在更新MRTCA列車參數檢核設定:', params);
      
      const response = await axios.put('/api/MRTCA/FieldConstraint/UpdateTrain', params);
      
      console.log('MRTCA列車參數檢核設定更新響應:', response.data);
      
      if (!response.data) {
        throw new Error('響應數據為空');
      }

      // 添加Success字段以保持一致性
      if (typeof response.data.Success === 'undefined') {
        response.data.Success = true;
      }

      return response.data;
    } catch (error) {
      console.error('更新MRTCA列車參數檢核設定失敗:', error);
      throw error;
    }
  },

  // 更新中間站參數檢核設定
  updateIntermediateStation: async (params) => {
    try {
      console.log('正在更新MRTCA中間站參數檢核設定:', params);
      
      const response = await axios.put('/api/MRTCA/FieldConstraint/UpdateIntermediateStation', params);
      
      console.log('MRTCA中間站參數檢核設定更新響應:', response.data);
      
      if (!response.data) {
        throw new Error('響應數據為空');
      }

      if (typeof response.data.Success === 'undefined') {
        response.data.Success = true;
      }

      return response.data;
    } catch (error) {
      console.error('更新MRTCA中間站參數檢核設定失敗:', error);
      throw error;
    }
  },

  // 更新站前折返參數檢核設定
  updateReturnBeforeStation: async (params) => {
    try {
      console.log('正在更新MRTCA站前折返參數檢核設定:', params);
      
      const response = await axios.put('/api/MRTCA/FieldConstraint/UpdateReturnBeforeStation', params);
      
      console.log('MRTCA站前折返參數檢核設定更新響應:', response.data);
      
      if (!response.data) {
        throw new Error('響應數據為空');
      }

      if (typeof response.data.Success === 'undefined') {
        response.data.Success = true;
      }

      return response.data;
    } catch (error) {
      console.error('更新MRTCA站前折返參數檢核設定失敗:', error);
      throw error;
    }
  },

  // 更新站後折返參數檢核設定
  updateReturnAfterStation: async (params) => {
    try {
      console.log('正在更新MRTCA站後折返參數檢核設定:', params);
      
      const response = await axios.put('/api/MRTCA/FieldConstraint/UpdateReturnAfterStation', params);
      
      console.log('MRTCA站後折返參數檢核設定更新響應:', response.data);
      
      if (!response.data) {
        throw new Error('響應數據為空');
      }

      if (typeof response.data.Success === 'undefined') {
        response.data.Success = true;
      }

      return response.data;
    } catch (error) {
      console.error('更新MRTCA站後折返參數檢核設定失敗:', error);
      throw error;
    }
  },

  // 更新中央線參數檢核設定
  updateCentralLine: async (params) => {
    try {
      console.log('正在更新MRTCA中央線參數檢核設定:', params);
      
      const response = await axios.put('/api/MRTCA/FieldConstraint/UpdateCentralLine', params);
      
      console.log('MRTCA中央線參數檢核設定更新響應:', response.data);
      
      if (!response.data) {
        throw new Error('響應數據為空');
      }

      if (typeof response.data.Success === 'undefined') {
        response.data.Success = true;
      }

      return response.data;
    } catch (error) {
      console.error('更新MRTCA中央線參數檢核設定失敗:', error);
      throw error;
    }
  },

  // 更新連接點參數檢核設定
  updateConnectionPoint: async (params) => {
    try {
      console.log('正在更新MRTCA連接點參數檢核設定:', params);
      
      const response = await axios.put('/api/MRTCA/FieldConstraint/UpdateConnectionPoint', params);
      
      console.log('MRTCA連接點參數檢核設定更新響應:', response.data);
      
      if (!response.data) {
        throw new Error('響應數據為空');
      }

      if (typeof response.data.Success === 'undefined') {
        response.data.Success = true;
      }

      return response.data;
    } catch (error) {
      console.error('更新MRTCA連接點參數檢核設定失敗:', error);
      throw error;
    }
  },

  // 獲取全域參數檢核設定
  getGlobalSetting: async (projectId) => {
    try {
      console.log('正在獲取MRTCA全域參數檢核設定，ProjectId:', projectId);
      
      const cleanProjectId = typeof projectId === 'object' && projectId.ProjectId 
        ? projectId.ProjectId 
        : projectId;
        
      const response = await axios.get('/api/MRTCA/FieldConstraint/GetGlobalSetting', {
        params: { ProjectId: cleanProjectId }
      });
      
      console.log('MRTCA全域參數檢核設定響應:', response.data);
      
      if (!response.data) {
        throw new Error('響應數據為空');
      }

      // 添加Success字段以保持一致性
      if (typeof response.data.Success === 'undefined') {
        response.data.Success = true;
      }

      return response.data;
    } catch (error) {
      console.error('獲取MRTCA全域參數檢核設定失敗:', error);
      throw error;
    }
  },

  // 獲取列車參數檢核設定
  getTrain: async (projectId) => {
    try {
      console.log('正在獲取MRTCA列車參數檢核設定，ProjectId:', projectId);
      
      const cleanProjectId = typeof projectId === 'object' && projectId.ProjectId 
        ? projectId.ProjectId 
        : projectId;
        
      const response = await axios.get('/api/MRTCA/FieldConstraint/GetTrain', {
        params: { ProjectId: cleanProjectId }
      });
      
      console.log('MRTCA列車參數檢核設定響應:', response.data);
      
      if (!response.data) {
        throw new Error('響應數據為空');
      }

      // 添加Success字段以保持一致性
      if (typeof response.data.Success === 'undefined') {
        response.data.Success = true;
      }

      return response.data;
    } catch (error) {
      console.error('獲取MRTCA列車參數檢核設定失敗:', error);
      throw error;
    }
  },

  // 獲取中間站參數檢核設定
  getIntermediateStation: async (projectId) => {
    try {
      console.log('正在獲取MRTCA中間站參數檢核設定，ProjectId:', projectId);
      
      const cleanProjectId = typeof projectId === 'object' && projectId.ProjectId 
        ? projectId.ProjectId 
        : projectId;
        
      const response = await axios.get('/api/MRTCA/FieldConstraint/GetIntermediateStation', {
        params: { ProjectId: cleanProjectId }
      });
      
      console.log('MRTCA中間站參數檢核設定響應:', response.data);
      
      if (!response.data) {
        throw new Error('響應數據為空');
      }

      if (typeof response.data.Success === 'undefined') {
        response.data.Success = true;
      }

      return response.data;
    } catch (error) {
      console.error('獲取MRTCA中間站參數檢核設定失敗:', error);
      throw error;
    }
  },

  // 獲取站前折返參數檢核設定
  getReturnBeforeStation: async (projectId) => {
    try {
      console.log('正在獲取MRTCA站前折返參數檢核設定，ProjectId:', projectId);
      
      const cleanProjectId = typeof projectId === 'object' && projectId.ProjectId 
        ? projectId.ProjectId 
        : projectId;
        
      const response = await axios.get('/api/MRTCA/FieldConstraint/GetReturnBeforeStation', {
        params: { ProjectId: cleanProjectId }
      });
      
      console.log('MRTCA站前折返參數檢核設定響應:', response.data);
      
      if (!response.data) {
        throw new Error('響應數據為空');
      }

      if (typeof response.data.Success === 'undefined') {
        response.data.Success = true;
      }

      return response.data;
    } catch (error) {
      console.error('獲取MRTCA站前折返參數檢核設定失敗:', error);
      throw error;
    }
  },

  // 獲取站後折返參數檢核設定
  getReturnAfterStation: async (projectId) => {
    try {
      console.log('正在獲取MRTCA站後折返參數檢核設定，ProjectId:', projectId);
      
      const cleanProjectId = typeof projectId === 'object' && projectId.ProjectId 
        ? projectId.ProjectId 
        : projectId;
        
      const response = await axios.get('/api/MRTCA/FieldConstraint/GetReturnAfterStation', {
        params: { ProjectId: cleanProjectId }
      });
      
      console.log('MRTCA站後折返參數檢核設定響應:', response.data);
      
      if (!response.data) {
        throw new Error('響應數據為空');
      }

      if (typeof response.data.Success === 'undefined') {
        response.data.Success = true;
      }

      return response.data;
    } catch (error) {
      console.error('獲取MRTCA站後折返參數檢核設定失敗:', error);
      throw error;
    }
  },

  // 獲取中央線參數檢核設定
  getCentralLine: async (projectId) => {
    try {
      console.log('正在獲取MRTCA中央線參數檢核設定，ProjectId:', projectId);
      
      const cleanProjectId = typeof projectId === 'object' && projectId.ProjectId 
        ? projectId.ProjectId 
        : projectId;
        
      const response = await axios.get('/api/MRTCA/FieldConstraint/GetCentralLine', {
        params: { ProjectId: cleanProjectId }
      });
      
      console.log('MRTCA中央線參數檢核設定響應:', response.data);
      
      if (!response.data) {
        throw new Error('響應數據為空');
      }

      if (typeof response.data.Success === 'undefined') {
        response.data.Success = true;
      }

      return response.data;
    } catch (error) {
      console.error('獲取MRTCA中央線參數檢核設定失敗:', error);
      throw error;
    }
  },

  // 獲取連接點參數檢核設定
  getConnectionPoint: async (projectId) => {
    try {
      console.log('正在獲取MRTCA連接點參數檢核設定，ProjectId:', projectId);
      
      const cleanProjectId = typeof projectId === 'object' && projectId.ProjectId 
        ? projectId.ProjectId 
        : projectId;
        
      const response = await axios.get('/api/MRTCA/FieldConstraint/GetConnectionPoint', {
        params: { ProjectId: cleanProjectId }
      });
      
      console.log('MRTCA連接點參數檢核設定響應:', response.data);
      
      if (!response.data) {
        throw new Error('響應數據為空');
      }

      if (typeof response.data.Success === 'undefined') {
        response.data.Success = true;
      }

      return response.data;
    } catch (error) {
      console.error('獲取MRTCA連接點參數檢核設定失敗:', error);
      throw error;
    }
  }
};

// 全局設置相關 API
export const globalSetting = {
  // 取得指定專案的全局設置
  get: async (projectId) => {
    const response = await axios.get('/api/MRTCA/GlobalSetting/Get', {
      params: {
        ProjectId: projectId
      }
    });
    return response.data;
  },

  // 更新指定專案的全局設置
  update: async (params) => {
    const response = await axios.put('/api/MRTCA/GlobalSetting/Update', params);
    return response.data;
  }
};

// 中間站相關 API
export const intermediateStation = {
  // 取得指定中間站
  get: async (intermediateStationId) => {
    const response = await axios.get('/api/MRTCA/IntermediateStation/Get', {
      params: {
        IntermediateStationId: intermediateStationId
      }
    });
    return response.data;
  },

  // 更新中間站
  update: async (params) => {
    const response = await axios.put('/api/MRTCA/IntermediateStation/Update', params);
    return response.data;
  }
};

// 專案相關 API
export const project = {
  // 取得指定專案
  get: async (projectId, accountId) => {
    const response = await axios.get('/api/MRTCA/Project/Get', {
      params: {
        ProjectId: projectId,
        AccountId: accountId
      }
    });
    return response.data;
  },

  // 取得當前帳號所有專案
  index: async (limit, page) => {
    try {
      console.log('正在獲取專案列表，參數：', { limit, page });

      if (!limit || !page) {
        throw new Error('缺少必要參數：limit 和 page');
      }

      const response = await axios.get('/api/MRTCA/Project/Index', {
        params: {
          Limit: limit,
          Page: page
        }
      });

      console.log('專案列表響應：', response);

      // 檢查響應數據
      if (!response.data) {
        console.error('響應數據為空');
        throw new Error('響應數據為空');
      }

      console.log('響應數據：', response.data);

      // 檢查響應數據結構
      if (!response.data.Projects) {
        console.warn('未獲取到專案列表數據，返回空數組');
        response.data.Projects = [];
      }

      // 添加Success字段以保持一致性
      response.data.Success = true;

      return response.data;
    } catch (error) {
      console.error('獲取專案列表時發生錯誤：', error);
      if (error.response) {
        // 服務器返回錯誤狀態碼
        const status = error.response.status;
        const message = error.response.data?.Message || error.response.data?.message || '未知錯誤';
        console.error('服務器錯誤響應：', { status, message, data: error.response.data });
        throw new Error(`獲取專案列表失敗 (${status}): ${message}`);
      } else if (error.request) {
        // 請求已發出但沒有收到響應
        console.error('網絡錯誤：', error.request);
        throw new Error('網絡錯誤：無法連接到服務器');
      }
      // 其他錯誤直接拋出
      throw error;
    }
  },

  // 建立專案
  create: async (params) => {
    const response = await axios.post('/api/MRTCA/Project/Create', {
      ProjectName: params.projectName
    });
    return response.data;
  },

  // 更新專案
  update: async (project) => {
    const response = await axios.put('/api/MRTCA/Project/Update', project);
    return response.data;
  },

  // 匯出專案
  export: async (projectId, projectName) => {
    try {
      const response = await axios.post('/api/MRTCA/Project/Export', { ProjectId: projectId });
      const fileContent = response.data?.JsonData || response.data?.File;

      if (fileContent) {
        const blob = new Blob([fileContent], { type: 'application/json;charset=utf-8' });

        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        
        // Extract base name from server response or use provided projectName
        // Ensure the file extension is always .mrtca (not .json)
        let baseName = projectName || 'project';
        if (response.data.FileName) {
          // Remove any existing extension (.json, .mrtca, etc.) from server-provided filename
          baseName = response.data.FileName.replace(/\.(json|mrtca)$/i, '');
        }
        // Ensure baseName doesn't already have an extension
        baseName = baseName.replace(/\.(json|mrtca)$/i, '');
        const fileName = `${baseName}.mrtca`;
        
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(link.href);
      } else {
        console.error('無效的伺服器回應:', response.data);
        throw new Error(response.data.Message || '匯出專案失敗：無效的伺服器回應');
      }
    } catch (error) {
      console.error('匯出專案失敗:', error);
      throw error;
    }
  },

  // 匯入專案
  import: async (file) => {
    try {
      const jsonData = await new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = (event) => resolve(event.target.result);
        reader.onerror = (error) => reject(error);
        reader.readAsText(file);
      });

      const response = await axios.post('/api/MRTCA/Project/Import', {
        JsonData: jsonData
      }, {
        headers: {
          'Content-Type': 'application/json',
        },
      });

      if (!response.data?.Success) {
        throw new Error(response.data?.Message || '匯入專案失敗');
      }
      return response.data;
    } catch (error) {
      console.error('匯入專案失敗:', error);
      throw error;
    }
  },

  // 刪除專案
  delete: async (projectId) => {
    const response = await axios.delete('/api/MRTCA/Project/Delete', {
      data: { ProjectId: projectId }
    });
    return response.data;
  },

  // 另存專案
  clone: async (projectId, newProjectName) => {
    const response = await axios.post('/api/MRTCA/Project/Clone', {
      ProjectId: projectId,
      ProjectName: newProjectName
    });
    return response.data;
  },

  // 取得範本
  getTemplate: async () => {
    const response = await axios.get('/api/MRTCA/Project/GetTemplate');
    return response.data;
  },

  // 建立範本
  createTemplate: async (params) => {
    const response = await axios.post('/api/MRTCA/Project/CreateTemplate', params);
    return response.data;
  },

  // 使用範本建立專案
  cloneTemplate: async (params) => {
    const response = await axios.post('/api/MRTCA/Project/CloneTemplate', params);
    return response.data;
  }
};

// 站後折返相關 API
export const returnAfterStation = {
  // 取得指定站後折返參數
  get: async (returnAfterStationId) => {
    const response = await axios.get('/api/MRTCA/ReturnAfterStation/Get', {
      params: {
        ReturnAfterStationId: returnAfterStationId
      }
    });
    return response.data;
  },

  // 更新站後折返參數
  update: async (params) => {
    const response = await axios.put('/api/MRTCA/ReturnAfterStation/Update', params);
    return response.data;
  }
};

// 站前折返相關 API
export const returnBeforeStation = {
  // 取得指定站前折返參數
  get: async (returnBeforeStationId) => {
    const response = await axios.get('/api/MRTCA/ReturnBeforeStation/Get', {
      params: {
        ReturnBeforeStationId: returnBeforeStationId
      }
    });
    return response.data;
  },

  // 更新站前折返參數
  update: async (params) => {
    const response = await axios.put('/api/MRTCA/ReturnBeforeStation/Update', params);
    return response.data;
  }
};

// 空間參考點相關 API
export const spatialReferencePoint = {
  // 取得指定空間參考點
  get: async (spatialReferencePointId, projectId) => {
    try {
      const response = await axios.get('/api/MRTCA/SpatialReferencePoint/Get', {
        params: {
          SpatialReferencePointId: spatialReferencePointId,
          ProjectId: projectId
        },
        timeout: 15000 // 15 seconds timeout
      });
      return response.data;
    } catch (error) {
      if (error.code === 'ECONNABORTED') {
        console.error('獲取空間參考點超時:', error);
        throw new Error('獲取空間參考點數據超時，請檢查後端服務器狀態。');
      }
      console.error('獲取空間參考點失敗:', error.response || error.request || error.message);
      throw error;
    }
  },

  // 建立空間參考點
  create: async (params) => {
    try {
      // 驗證必填欄位
      if (!params.SpatialReferencePointName || params.SpatialReferencePointName.trim() === '') {
        throw new Error(`新站點的名稱不能為空`);
      }

      // 確保請求體只包含 API 定義的字段，並使用大寫駝峰命名
      const requestBody = {
        ProjectId: params.ProjectId, // Create API needs ProjectId
        SpatialReferencePointName: params.SpatialReferencePointName.trim(),
        SpatialReferencePointForm: params.SpatialReferencePointForm
        // Do not include SpatialReferencePointId for creation
      };
      console.log('創建空間參考點請求體:', JSON.stringify(requestBody, null, 2));
      const response = await axios.post('/api/MRTCA/SpatialReferencePoint/Create', requestBody);
      console.log('創建空間參考點響應:', response.data);
      return response.data;
    } catch (error) {
      console.error('創建空間參考點失敗:', error.response || error.request || error.message);
      if (error.response) {
        console.error('服務器錯誤響應:', {
          status: error.response.status,
          data: error.response.data
        });
      }
      throw error;
    }
  },

  // 更新空間參考點
  update: async (point) => {
    try {
      // 驗證必填欄位
      if (!point.SpatialReferencePointName || point.SpatialReferencePointName.trim() === '') {
        throw new Error(`站點 ID ${point.SpatialReferencePointId} 的名稱不能為空`);
      }

      // 建立包含所有參數的請求體
      const requestBody = {
        SpatialReferencePointId: point.SpatialReferencePointId,
        SpatialReferencePointName: point.SpatialReferencePointName.trim(), // 去除前後空格
        SpatialReferencePointForm: point.SpatialReferencePointForm
      };

      // 將所有其他參數（詳細參數）也加入請求體
      Object.keys(point).forEach(key => {
        if (!['SpatialReferencePointId', 'SpatialReferencePointName', 'SpatialReferencePointForm'].includes(key)) {
          requestBody[key] = point[key];
        }
      });

      console.log(`更新空間參考點 (ID: ${point.SpatialReferencePointId}) 請求體:`, JSON.stringify(requestBody, null, 2));
      const response = await axios.put('/api/MRTCA/SpatialReferencePoint/Update', requestBody);
      console.log(`更新空間參考點 (ID: ${point.SpatialReferencePointId}) 響應:`, response.data);
      return response.data;
    } catch (error) {
      console.error(`更新空間參考點 (ID: ${point.SpatialReferencePointId}) 失敗:`, error.response || error.request || error.message);
      if (error.response) {
        console.error('服務器錯誤響應:', {
          status: error.response.status,
          data: error.response.data,
          headers: error.response.headers
        });
      }
      error.pointId = point.SpatialReferencePointId;
      throw error;
    }
  },

  // 依據站點類型更新空間參考點詳細參數
  updateByType: async (point) => {
    try {
      console.log('根據站點類型更新空間參考點:', {
        type: point.SpatialReferencePointForm,
        pointId: point.SpatialReferencePointId
      });

      // 直接使用傳入的 point，不再調用 ensureDetailedParameterIds
      // 因為在調用此方法前，已經在 urbanStore.js 中設置了正確的個別類型 ID
      console.log('使用的詳細參數:', JSON.stringify(point, null, 2));

      switch (point.SpatialReferencePointForm) {
        case 1: // 中間站
          return await spatialReferencePoint.updateIntermediateStation(point);
        case 2: // 站前折返
          return await spatialReferencePoint.updateReturnBeforeStation(point);
        case 3: // 站後折返
          return await spatialReferencePoint.updateReturnAfterStation(point);
        case 4: // 中央避車線折返
          return await spatialReferencePoint.updateCentralLine(point);
        case 5: // 銜接點
          return await spatialReferencePoint.updateConnectingPoint(point);
        default:
          throw new Error(`不支援的站點類型: ${point.SpatialReferencePointForm}`);
      }
    } catch (error) {
      console.error('依據站點類型更新空間參考點失敗:', error);
      throw error;
    }
  },

  // 確保詳細參數 ID 存在，如果不存在則從伺服器取得
  ensureDetailedParameterIds: async (point) => {
    try {
      const requiredIdField = spatialReferencePoint.getRequiredIdField(point.SpatialReferencePointForm);
      
      // 如果已經有需要的 ID，直接返回
      if (point[requiredIdField]) {
        console.log(`已有 ${requiredIdField}:`, point[requiredIdField]);
        return point;
      }

      // 沒有 ID，需要從伺服器取得完整的空間參考點資訊
      console.log('缺少詳細參數 ID，正在從伺服器取得...');
      const spatialRefResponse = await spatialReferencePoint.get(point.SpatialReferencePointId, point.ProjectId);
      
      console.log('伺服器響應:', JSON.stringify(spatialRefResponse, null, 2));
      
      // 處理不同的響應格式
      let serverPoint;
      if (spatialRefResponse.Success && spatialRefResponse.Result) {
        // 標準格式：{Success: true, Result: {...}}
        serverPoint = spatialRefResponse.Result;
      } else if (spatialRefResponse.SpatialReferencePoints && spatialRefResponse.SpatialReferencePoints.length > 0) {
        // 列表格式：{SpatialReferencePoints: [...]}
        serverPoint = spatialRefResponse.SpatialReferencePoints.find(p => p.SpatialReferencePointId === point.SpatialReferencePointId);
      } else {
        throw new Error('伺服器響應格式不正確或沒有找到對應的空間參考點');
      }

      if (!serverPoint) {
        throw new Error('無法在伺服器響應中找到對應的空間參考點');
      }

      const detailedId = serverPoint[requiredIdField];
      
      if (!detailedId) {
        throw new Error(`伺服器上也沒有 ${requiredIdField}，可能需要先創建詳細參數`);
      }

      // 合併伺服器資料和當前要更新的資料
      const enrichedPoint = {
        ...point,
        [requiredIdField]: detailedId
      };

      console.log(`已從伺服器取得 ${requiredIdField}:`, detailedId);
      return enrichedPoint;
    } catch (error) {
      console.error('確保詳細參數 ID 時發生錯誤:', error);
      throw error;
    }
  },

  // 根據站點類型取得所需的詳細參數 ID 欄位名稱
  getRequiredIdField: (pointType) => {
    switch (pointType) {
      case 1: return 'IntermediateStationId';
      case 2: return 'ReturnBeforeStationId';
      case 3: return 'ReturnAfterStationId';
      case 4: return 'CentralLineId';
      case 5: return 'ConnectingPointId';
      default: throw new Error(`不支援的站點類型: ${pointType}`);
    }
  },

  // 更新中間站詳細參數
  updateIntermediateStation: async (point) => {
    try {
      if (!point.IntermediateStationId) {
        throw new Error('中間站參數編號不能為空');
      }

      const requestBody = {
        IntermediateStationId: point.IntermediateStationId,
        InStationSlopeForward: point.InStationSlopeForward || 0,
        InStationSlopeReverse: point.InStationSlopeReverse || 0,
        OutStationSlopeForward: point.OutStationSlopeForward || 0,
        OutStationSlopeReverse: point.OutStationSlopeReverse || 0,
        StationPositionDistanceForward: point.StationPositionDistanceForward || 0,
        StationPositionDistanceReverse: point.StationPositionDistanceReverse || 0,
        OverlapLengthForward: point.OverlapLengthForward || 0,
        OverlapLengthReverse: point.OverlapLengthReverse || 0,
        StopTimeForward: point.StopTimeForward || 0,
        StopTimeReverse: point.StopTimeReverse || 0,
        CruiseSpeedAfterForward: point.CruiseSpeedAfterForward || 0,
        CruiseSpeedAfterReverse: point.CruiseSpeedAfterReverse || 0,
        CruiseSpeedBeforeForward: point.CruiseSpeedBeforeForward || 0,
        CruiseSpeedBeforeReverse: point.CruiseSpeedBeforeReverse || 0,
        SafetyCoefficientForward: point.SafetyCoefficientForward || 0,
        SafetyCoefficientReverse: point.SafetyCoefficientReverse || 0
      };

      console.log('更新中間站請求體:', JSON.stringify(requestBody, null, 2));
      const response = await axios.put('/api/MRTCA/IntermediateStation/Update', requestBody);
      console.log('更新中間站響應:', response.data);
      return response.data;
    } catch (error) {
      console.error('更新中間站失敗:', error.response || error.request || error.message);
      throw error;
    }
  },

  // 更新站前折返詳細參數
  updateReturnBeforeStation: async (point) => {
    try {
      if (!point.ReturnBeforeStationId) {
        throw new Error('站前折返參數編號不能為空');
      }

      const requestBody = {
        ReturnBeforeStationId: point.ReturnBeforeStationId,
        AlternatelyStop: point.AlternatelyStop || false,
        Slope: point.Slope || 0,
        DistanceToCrossover: point.DistanceToCrossover || 0,
        CrossoverLength: point.CrossoverLength || 0,
        StopTime: point.StopTime || 0,
        TurnoutSpeedLimit: point.TurnoutSpeedLimit || 0,
        BeforeStationSpeed: point.BeforeStationSpeed || 0,
        SafetyFactor: point.SafetyFactor || 0
      };

      console.log('更新站前折返請求體:', JSON.stringify(requestBody, null, 2));
      const response = await axios.put('/api/MRTCA/ReturnBeforeStation/Update', requestBody);
      console.log('更新站前折返響應:', response.data);
      return response.data;
    } catch (error) {
      console.error('更新站前折返失敗:', error.response || error.request || error.message);
      throw error;
    }
  },

  // 更新站後折返詳細參數
  updateReturnAfterStation: async (point) => {
    try {
      if (!point.ReturnAfterStationId) {
        throw new Error('站後折返參數編號不能為空');
      }

      const requestBody = {
        ReturnAfterStationId: point.ReturnAfterStationId,
        AlternatelyStop: point.AlternatelyStop || false,
        Slope: point.Slope || 0,
        DistanceToCrossover: point.DistanceToCrossover || 0,
        CrossoverLength: point.CrossoverLength || 0,
        DistanceToRearTrack: point.DistanceToRearTrack || 0,
        StopTimeAtRearTrack: point.StopTimeAtRearTrack || 0,
        TurnoutSpeedLimit: point.TurnoutSpeedLimit || 0
      };

      console.log('更新站後折返請求體:', JSON.stringify(requestBody, null, 2));
      const response = await axios.put('/api/MRTCA/ReturnAfterStation/Update', requestBody);
      console.log('更新站後折返響應:', response.data);
      return response.data;
    } catch (error) {
      console.error('更新站後折返失敗:', error.response || error.request || error.message);
      throw error;
    }
  },

  // 更新中央避車線折返詳細參數
  updateCentralLine: async (point) => {
    try {
      if (!point.CentralLineId) {
        throw new Error('中央避車線參數編號不能為空');
      }

      const requestBody = {
        CentralLineId: point.CentralLineId,
        Slope: point.Slope || 0,
        DistanceToCrossover: point.DistanceToCrossover || 0,
        CrossoverLength: point.CrossoverLength || 0,
        DistanceToCentralLine: point.DistanceToCentralLine || 0,
        StopTimeAtCentralLine: point.StopTimeAtCentralLine || 0,
        TurnoutSpeedLimit: point.TurnoutSpeedLimit || 0
      };

      console.log('更新中央避車線折返請求體:', JSON.stringify(requestBody, null, 2));
      const response = await axios.put('/api/MRTCA/CentralLine/Update', requestBody);
      console.log('更新中央避車線折返響應:', response.data);
      return response.data;
    } catch (error) {
      console.error('更新中央避車線折返失敗:', error.response || error.request || error.message);
      throw error;
    }
  },

  // 更新銜接點詳細參數
  updateConnectingPoint: async (point) => {
    try {
      if (!point.ConnectingPointId) {
        throw new Error('銜接點參數編號不能為空');
      }

      const requestBody = {
        ConnectingPointId: point.ConnectingPointId,
        MainLineSlope: point.MainLineSlope || 0,
        LateralLineSlope: point.LateralLineSlope || 0,
        CrossoverLength: point.CrossoverLength || 0,
        TurnoutSpeedLimit: point.TurnoutSpeedLimit || 0,
        MainLineSpeed: point.MainLineSpeed || 0,
        LateralLineSpeed: point.LateralLineSpeed || 0,
        MainLineSafetyFactor: point.MainLineSafetyFactor || 0,
        LateralLineSafetyFactor: point.LateralLineSafetyFactor || 0,
        ConnectingPointRatio: point.ConnectingPointRatio || 0
      };

      console.log('更新銜接點請求體:', JSON.stringify(requestBody, null, 2));
      const response = await axios.put('/api/MRTCA/ConnectingPoint/Update', requestBody);
      console.log('更新銜接點響應:', response.data);
      return response.data;
    } catch (error) {
      console.error('更新銜接點失敗:', error.response || error.request || error.message);
      throw error;
    }
  },

  // 刪除空間參考點
  delete: async (spatialReferencePointId) => {
    try {
      const response = await axios.delete('/api/MRTCA/SpatialReferencePoint/Delete', {
        data: {
          SpatialReferencePointId: Number(spatialReferencePointId)
        }
      });
      return response.data;
    } catch (error) {
      console.error('刪除空間參考點失敗:', error.response || error.request || error.message);
      if (error.response) {
        console.error('Server response data:', error.response.data);
        console.error('Server response status:', error.response.status);
      }
      throw error;
    }
  },

  // 重新排序空間參考點
  reorder: async (projectId, orderedIds) => {
    try {
      // Map the orderedIds array to the required structure
      const spatialReferencePointOrders = orderedIds.map((id, index) => ({
        SpatialReferencePointId: id,
        Order: index // Order starts from 0
      }));

      const requestBody = {
        ProjectId: projectId,
        SpatialReferencePointOrders: spatialReferencePointOrders
      };
      console.log('重新排序空間參考點請求體:', JSON.stringify(requestBody, null, 2));
      const response = await axios.post('/api/MRTCA/SpatialReferencePoint/Reorder', requestBody);
      console.log('重新排序空間參考點響應:', response.data);
      return response.data;
    } catch (error) {
      console.error('重新排序空間參考點失敗:', error.response || error.request || error.message);
      if (error.response) {
        console.error('服務器錯誤響應:', {
          status: error.response.status,
          data: error.response.data,
          headers: error.response.headers
        });
      }
      throw error;
    }
  }
};

// 列車相關 API
export const train = {
  // 取得指定列車
  get: async (projectId) => {
    try {
      console.log('mrtca.js - Sending GET /api/MRTCA/Train/Get with params:', { ProjectId: projectId });
      const response = await axios.get('/api/MRTCA/Train/Get', {
        params: {
          ProjectId: projectId
        }
      });
      console.log('mrtca.js - Train/Get response:', response.data);
      return response.data;
    } catch (error) {
      console.error('獲取列車參數失敗:', error.response || error.request || error.message);
      if (error.response) {
        console.error('Server response data:', error.response.data);
        console.error('Server response status:', error.response.status);
      }
      throw error;
    }
  },

  // 建立列車
  create: async (params) => {
    try {
      // 確保使用正確的字段名稱
      const requestBody = {
        ProjectId: params.ProjectId,
        TrainLength: params.TrainLength,
        DrivingAcceleration: params.DrivingAcceleration,
        DrivingDeceleration: params.DrivingDeceleration,
        BrakeEffectiveFactor: params.BrakeEffectiveFactor,
        SeatNumber: params.SeatNumber,
        StandingAreaCapacity: params.StandingAreaCapacity,
        PassengerCapacity: params.PassengerCapacity
      };
      console.log('mrtca.js - Sending POST /api/MRTCA/Train/Create with body:', requestBody);
      const response = await axios.post('/api/MRTCA/Train/Create', requestBody);
      console.log('mrtca.js - Train/Create response:', response.data);
      return response.data;
    } catch (error) {
      console.error('創建列車參數失敗:', error.response || error.request || error.message);
      if (error.response) {
        console.error('Server response data:', error.response.data);
        console.error('Server response status:', error.response.status);
      }
      throw error;
    }
  },

  // 更新列車
  update: async (params) => {
    try {
      // 確保使用正確的字段名稱
      const requestBody = {
        ProjectId: params.ProjectId,
        TrainId: params.TrainId,
        TrainLength: params.TrainLength,
        DrivingAcceleration: params.DrivingAcceleration,
        DrivingDeceleration: params.DrivingDeceleration,
        BrakeEffectiveFactor: params.BrakeEffectiveFactor,
        SeatNumber: params.SeatNumber,
        StandingAreaCapacity: params.StandingAreaCapacity,
        PassengerCapacity: params.PassengerCapacity
      };
      console.log('mrtca.js - Sending PUT /api/MRTCA/Train/Update with body:', requestBody);
      const response = await axios.put('/api/MRTCA/Train/Update', requestBody);
      console.log('mrtca.js - Train/Update response:', response.data);
      return response.data;
    } catch (error) {
      console.error('更新列車參數失敗:', error.response || error.request || error.message);
      if (error.response) {
        console.error('Server response data:', error.response.data);
        console.error('Server response status:', error.response.status);
      }
      throw error;
    }
  }
}; 